import { render, staticRenderFns } from "./InlineMessage.vue?vue&type=template&id=2bc5b6dc&scoped=true"
import script from "./InlineMessage.vue?vue&type=script&lang=js"
export * from "./InlineMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc5b6dc",
  null
  
)

export default component.exports